import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

interface Segment {
  name: string;
  count: number;
  icon: React.ReactNode;
  color: string;
}

interface CustomerSegmentsProps {
  segments: Segment[];
  onSegmentClick: (tagName: string) => void;
}

const CustomerSegments: React.FC<CustomerSegmentsProps> = ({ segments, onSegmentClick }) => {
  return (
    <Box sx={{ 
      display: 'grid', 
      gridTemplateColumns: { 
        xs: '1fr', 
        sm: 'repeat(2, 1fr)', 
        md: 'repeat(4, 1fr)' 
      }, 
      gap: 3, 
      mb: 4 
    }}>
      {segments.map((segment) => (
        <Card
          key={segment.name}
          sx={{
            bgcolor: 'background.paper',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'divider',
            cursor: 'pointer',
            transition: 'all 0.3s',
            '&:hover': {
              transform: 'translateY(-4px)',
              borderColor: `${segment.color}50`,
              boxShadow: `0 4px 12px ${segment.color}15`,
            },
          }}
          onClick={() => onSegmentClick(segment.name === 'All Customers' ? '' : segment.name)}
        >
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: 1,
                  bgcolor: `${segment.color}20`,
                  display: 'inline-flex',
                }}
              >
                <Box sx={{ fontSize: 28, color: segment.color }}>
                  {segment.icon}
                </Box>
              </Box>
              <Typography variant="h4" fontWeight={700}>
                {segment.count}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              {segment.name}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default CustomerSegments;